module.exports = __webpack_public_path__ + "assets/833dfb9828e6e5c50add79fbfc5b1b48.woff";